import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
// components
// middlewares
import { Navigate } from "react-router-dom";
import TakingGoodsMiddleware from "../../../../middleware/modules/warehouse/taking-goods";
import Form from "../../../../components/modules/warehouse/taking-goods/form";
import { Button, Modal } from "react-bootstrap";
import StoresMiddleware from "../../../../middleware/modules/master/store";
import { Helmet } from "react-helmet";
import i18n from "../../../../i18n";
import FormReturnGoods from "../../../../components/modules/warehouse/return-goods/form";
import ReturnGoodsMiddleware from "../../../../middleware/modules/warehouse/return-goods";

const mapStateToProps = ({ auth, returnGoods }) => ({
  isProcessing: returnGoods.isProcessing,
  isError: returnGoods.isError,
  errorMessage: returnGoods.errorMessage,
  datalist: returnGoods.data,
  dataGoods: returnGoods.dataGoods,
  showModal: returnGoods.showModal,
  showData:returnGoods.showData,
  helper: returnGoods.takingGoodsHelper,
  onSubmit: returnGoods.onSubmit,
});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      approve: (id, value, search) => ReturnGoodsMiddleware.beforeApprove(id, value, search),
      reject: (id, value, search) => ReturnGoodsMiddleware.beforeReject(id, value, search),
      closeModal: () => ReturnGoodsMiddleware.reset(),
      reset: () => ReturnGoodsMiddleware.resetList(),
      search: (data) => ReturnGoodsMiddleware.list(data),
      getDataGoods: (data) => ReturnGoodsMiddleware.getDataGoods(data),
      saveReturnGoods: (data, search) => ReturnGoodsMiddleware.beforeSaveReturn(data, search),
      getHelperFull: () => ReturnGoodsMiddleware.getHelperFull(),
    },
    dispatch 
  );
};
class FormContainer extends Component {
  static propTypes = {
    isAuthenticated: PropTypes.bool,
    isProcessing: PropTypes.bool,
    isRegistered: PropTypes.bool,
    isError: PropTypes.bool,
    isSuccess: PropTypes.bool,
    dataUpdate: PropTypes.object,
    errorMessage: PropTypes.any,
    onSubmit: PropTypes.bool,
  };

  static defaultProps = {
    isAuthenticated: false,
    isProcessing: false,
    isRegistered: false,
    isSuccess: false,
    isError: false,
    errorMessage: {},
    dataUpdate: null,
    onSubmit: false,
  };
  constructor(props) {
    super(props);
    this.state = {
      modal: {
        title: "",
        show: false,
      },
    };
    this.form = React.createRef();
    this.getDataGoods = this.getDataGoods.bind(this);
    this.saveReturnGoods = this.saveReturnGoods.bind(this);
    this.close = this.close.bind(this);
  }

  // componentWillMount() {
  //   const search = {
  //     limit: 10,
  //   };
  //   // this.props.reset();
  //   // this.props.search(search);
  //   // this.props.getHelperFull();
  // }

  getDataGoods(data){
    this.props.getDataGoods(data);
  }

  saveReturnGoods(data){
    this.props.saveReturnGoods(data);
  }

  close() {
    this.props.closeModal();
  }

  submitForm() {
    const { search } = this.props;
    const form = this.form.current.runSubmit(); 
    const params = {limit:10}
    if (!form) return; 
    this.props.saveReturnGoods(form, params);
  }

  render() {
    const {
      isNewRecord,
      onSubmit,
      showModal,
      titleModal,
      isReset,
      dataUpdate,
      isProcessing,
      isError,
      errorMessage,
    } = this.props;
    
    return (
      <>
        <Modal
          show={showModal}
          fullscreen={true}
        >
          <Modal.Header>
            <Modal.Title>{titleModal}</Modal.Title>
          </Modal.Header>
          <Helmet>
                <title>{titleModal}</title>
              </Helmet>
          <Modal.Body>
            <FormReturnGoods
             {...this.props}
              data={dataUpdate}
              ref={this.form}
              getDataGoods ={this.getDataGoods}
            />
          </Modal.Body>
          <Modal.Footer className={(!onSubmit)?"justify-content-between":"justify-content-center"}>
            {onSubmit ? (
              ""
            ) : (
              <Button variant="secondary" onClick={() => this.close(false)}>
                {i18n.t("Close")}
              </Button>
            )}
            <Button variant="primary" onClick={() => ((onSubmit)?false:this.submitForm(true))}>
              {onSubmit ? (
                <span className="indicator-progress show">
                  {i18n.t("Please wait...")}
                  <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                </span>
              ) : (
                <span className="indicator-label">{i18n.t("Save")}</span>
              )}
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(FormContainer);
